import { AuthorizationInfo } from 'src/Common/Utilities/AuthorizationInfo';

/**
 * Tenants whose Manage Action page is gated behind a flight.
 *
 * To gate a new tenant, add a single entry here — no other code changes are required.
 * A user who opens a gated tenant's action URL directly without the matching flight
 * will be shown the unauthorized page.
 */
export interface FlightGatedTenant {
  tenantId: string;
  flight: string;
}

export const FLIGHT_GATED_TENANTS: FlightGatedTenant[] = [];

/**
 * Returns true when the given tenant is flight-gated AND the user is missing the required flight.
 * Returns false for tenants that are not gated, so non-gated tenants are never affected.
 */
export const isTenantFlightUnauthorized = (
  tenantId: string | undefined,
  userFlights: string[] | undefined
): boolean => {
  if (!tenantId) return false;
  const gate = FLIGHT_GATED_TENANTS.find((item) => item.tenantId === tenantId);
  if (!gate) return false;
  return !AuthorizationInfo.isIncludedInRequiredFlights(userFlights ?? [], [gate.flight]);
};

// Generated by GitHub Copilot | Updated on: 2026-08-01 | 35 lines created | Config-driven flight gating for tenant Manage Action pages
// Generated by GitHub Copilot | Updated on: 2026-08-18 | 4 lines modified | Retired Marketplace entry from FLIGHT_GATED_TENANTS; dropped unused FieldConstants/UATConstants imports
